export default __webpack_public_path__ + "static/media/sf7.0bcf9b86.svg";